// controls/select.js — version refactorisée avec OptionsEditor
import React from "react";
import CommonControls from "./inc/Common";
import OptionsEditor from "./inc/OptionsEditor";

export function createSelectField() {
  return JSON.parse(
    JSON.stringify({
      type: "string",
      title: "Liste déroulante",
      "x-ui": "select",
      enum: [""],
      "x-options": [{ text: "> Sélectionner", value: "" }],
    })
  );
}

export function EditSelectField({ field, onChange }) {
  const handleOptionsChange = (options) => {
    const updatedField = {
      ...field,
      "x-options": options,
      enum: options.map((o) => o.value),
    };
    onChange(updatedField);
  };

  return (
    <>
      <CommonControls field={field} onChange={onChange} />
      <OptionsEditor
        initialOptions={field["x-options"]}
        onChange={handleOptionsChange}
        label="Options"
      />
    </>
  );
}

export const editSelectField = (props) => <EditSelectField {...props} />;

/* =========================================================
   🧩 FRONT — rendu du champ Select
   ========================================================= */
export const RenderSelectField = ({
  field,
  value,
  onChange,
  className,
  errorMessage    // <--- AJOUT
}) => {

  const options = field["x-options"] || [];
  const label = field.title || "";
  const required = field.required || false;

  return (
    <div
      className={`
        fb-field fb-select 
        ${field["x-bloc-class"] || "mb-3"} 
        ${className || ""}
      `}
    >

      {/* Label */}
      {label && (
        <label className={`form-label ${errorMessage ? "text-danger" : ""}`}>
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      {/* Select */}
      <select
        className={`
          form-select
          ${field["x-control-class"] || ""}
          ${errorMessage ? "is-invalid" : ""}
        `}
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {options.map((opt, i) => (
          <option key={i} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>

      {/* Message d’erreur */}
      {errorMessage && (
        <div className="invalid-feedback d-block mt-1">
          {errorMessage}
        </div>
      )}

    </div>
  );
};
